/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-empty-function */
import { DashboardCard, Flex, P } from 'styling/GlobalStyles'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IWidget } from 'types/dashboard.interface'
import { BodyText, TitleText } from 'styling/Typography'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { HrDashboardInnerWidgetContainer, HrDashboardTitleLine } from '../HrDashboard.styled'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { BarChart } from 'components/Chart/BarChart'

export const HrShiftsWidget = ({
    modalOpen,
    removeWidget,
    onDragOver,
    onDragStart,
    onDragDrop
}: IWidget) => {

    const { shiftsSummary } = useSelector((state: RootState) => state.hrDashboard)

    const Circle = ({ color }) => {
        return (
            <div style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: color,
                marginRight: 5
            }} />
        )
    }

    const sortedShifts = shiftsSummary?.shifts
        ? [...shiftsSummary.shifts].sort((a, b) => b.numberOfUsers - a.numberOfUsers)
        : [];

    const data = sortedShifts.slice(0, 5).map(s => ({
        value: s.numberOfUsers,
        name: s.name,
        color: s.color ? ('#' + s.color) : '#ff9900'
    }));

    const additionalShifts = sortedShifts.length > 5 ? [{
        value: sortedShifts.slice(5).reduce((acc, s) => acc + s.numberOfUsers, 0),
        name: 'Other',
        color: '#ff9900'
    }] : [];

    return (
        <DashboardCard
            draggable={modalOpen}
            onDragStartCapture={() => {
                onDragStart('shifts', 1)
            }}
            onDrop={onDragDrop}
            onDragEnd={(e) => {
                e.preventDefault()
            }}
            onDragOver={(e) => {
                e.preventDefault()
                onDragOver('shifts')
            }}
            width='1fr'
            style={{ gridArea: 'shifts', cursor: modalOpen ? 'grab' : 'normal' }}
        >
            {modalOpen && (
                <WidgetEditOverlay
                    onClick={(e) => {
                        removeWidget('shifts')
                        e.stopPropagation()
                    }}
                >
                    <P>Remove Widget</P>
                    <CloseIcon white />
                </WidgetEditOverlay>
            )}
            <TitleText weight='bold'>SHIFTS</TitleText>
            <HrDashboardInnerWidgetContainer style={{ width: '100%', height: '100%' }} >
                <Flex column between height='100%' gap='3rem'>
                    {[...data, ...additionalShifts].length ? <><Flex column gap='13px' >
                        {[...data, ...additionalShifts]?.map((s, i) => <HrDashboardTitleLine smallPaddingBottom key={i}  >
                            <Flex gap='2px' center >
                                <Circle color={s.color} />
                                <BodyText>
                                    {s.name}
                                </BodyText>
                            </Flex>
                            <TitleText weight='bold' >
                                {s.value}
                            </TitleText>
                        </HrDashboardTitleLine>)}
                    </Flex>
                        <BarChart height={150} data={[...data, ...additionalShifts]} /></> : <BodyText>No shifts available</BodyText>}

                </Flex>

            </HrDashboardInnerWidgetContainer>

        </DashboardCard>
    )
}
